"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendCKBWithSubkeyUnlock = void 0;
const ckb_sdk_utils_1 = require("@nervosnetwork/ckb-sdk-utils");
const constants_1 = require("../constants");
const rsa2048_1 = require("../signature/rsa2048");
const secp256k1_1 = require("../signature/secp256k1");
const secp256r1_1 = require("../signature/secp256r1");
const utils_1 = require("../utils");
const sendCKBWithSubkeyUnlock = (servicer, subPrivateKey, algIndex, from, to, amount, sigAlg = utils_1.SigAlg.Secp256r1) => __awaiter(void 0, void 0, void 0, function* () {
    const isMainnet = from.startsWith('ckb');
    const fromLock = (0, ckb_sdk_utils_1.addressToScript)(from);
    const cells = yield servicer.collector.getCells(fromLock);
    if (cells == undefined || cells.length == 0) {
        throw new Error('The from address has no live cells');
    }
    const cotaType = (0, constants_1.getCotaTypeScript)(isMainnet);
    const cotaCells = yield servicer.collector.getCells(fromLock, cotaType);
    if (!cotaCells || cotaCells.length === 0) {
        throw new Error("Cota cell doesn't exist");
    }
    const cotaCell = cotaCells[0];
    const cotaCellDep = {
        outPoint: cotaCell.outPoint,
        depType: 'code',
    };
    const { inputs, capacity: inputCapacity } = servicer.collector.collectInputs(cells, amount, constants_1.FEE);
    const toLock = (0, ckb_sdk_utils_1.addressToScript)(to);
    let outputs = [
        {
            capacity: `0x${amount.toString(16)}`,
            lock: toLock,
        },
    ];
    const changeCapacity = inputCapacity - constants_1.FEE - amount;
    outputs.push({
        capacity: `0x${changeCapacity.toString(16)}`,
        lock: fromLock,
    });
    const cellDeps = [cotaCellDep, (0, constants_1.getJoyIDCellDep)(isMainnet)];
    let pubkeyHash;
    if (sigAlg == utils_1.SigAlg.RSA2048) {
        const subPubkey = `0x${(0, utils_1.exportPubKey)((0, utils_1.pemToKey)(subPrivateKey))}`;
        pubkeyHash = (0, utils_1.append0x)((0, ckb_sdk_utils_1.blake160)(subPubkey, 'hex'));
    }
    else {
        const subPubkey = (0, utils_1.pubkeyFromPrivateKey)(subPrivateKey, sigAlg);
        pubkeyHash = sigAlg == utils_1.SigAlg.Secp256r1 ? (0, utils_1.append0x)((0, ckb_sdk_utils_1.blake160)(subPubkey, 'hex')) : (0, utils_1.append0x)((0, utils_1.keccak160)(subPubkey));
    }
    const req = {
        lockScript: (0, ckb_sdk_utils_1.serializeScript)(fromLock),
        pubkeyHash,
        algIndex,
    };
    const { unlockEntry } = yield servicer.aggregator.generateSubkeyUnlockSmt(req);
    const rawTx = {
        version: '0x0',
        cellDeps,
        headerDeps: [],
        inputs,
        outputs,
        outputsData: ['0x', '0x'],
        witnesses: [],
    };
    rawTx.witnesses = rawTx.inputs.map((_, i) => i > 0 ? '0x' : { lock: '', inputType: '', outputType: (0, utils_1.append0x)(unlockEntry) });
    let signedTx;
    if (sigAlg == utils_1.SigAlg.RSA2048) {
        const key = (0, utils_1.pemToKey)(subPrivateKey);
        signedTx = (0, rsa2048_1.signRSATx)(key, rawTx, constants_1.WITNESS_SUBKEY_MODE);
    }
    else {
        const key = (0, utils_1.keyFromPrivate)(subPrivateKey, sigAlg);
        signedTx = sigAlg == utils_1.SigAlg.Secp256r1 ? (0, secp256r1_1.signSecp256r1Tx)(key, rawTx, constants_1.WITNESS_SUBKEY_MODE) : (0, secp256k1_1.signSecp256k1Tx)(key, rawTx, constants_1.WITNESS_SUBKEY_MODE);
    }
    console.info(JSON.stringify(signedTx));
    let txHash = yield servicer.collector.getCkb().rpc.sendTransaction(signedTx, 'passthrough');
    console.info(`sendCKBWithSubkeyUnlock tx has been sent with tx hash ${txHash}`);
    return txHash;
});
exports.sendCKBWithSubkeyUnlock = sendCKBWithSubkeyUnlock;
